import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'

export const [CreditCardTypes, CreditCardTypeSchema] = EnumBuilder(
  'amex',
  'diners',
  'discover',
  'eftpos_au',
  'jcb',
  'link',
  'mastercard',
  'unionpay',
  'visa',
  'unknown'
)

export type CreditCardType = ZodSimplify<typeof CreditCardTypeSchema>
